import { createZustandStore } from '../../../zustand';

import { ISearchPackageState } from './type';

/**
 * This creates a local global state for Search Package selected filters and update the
 * filters
 */
export const useSearchPackageStore = createZustandStore<ISearchPackageState>()(
  (set) => ({
    selectedPackageLocation: '',
    selectedInboundSortFilter: 'ACTIVE',
    updateSelectedPackageLocation: (location) =>
      set(() => ({ selectedPackageLocation: location })),
    searchKey: '',
    updateSearchKey: (searchKey) => set(() => ({ searchKey })),
    specificFieldFilter: null,
    specificKeywordFilter: [],
    updateSpecificFieldFilter: (field) =>
      set(() => ({ specificFieldFilter: field })),
    updateSpecificKeywordFilter: (keyword) =>
      set(() => ({ specificKeywordFilter: keyword })),
    homeSortOrder: 'NEW',
    updateHomeSortOrder: (sortOrder) =>
      set(() => ({ homeSortOrder: sortOrder })),
    homeCalendarDateRange: null,
    updateHomeCalendarDateRange: (dateRange) =>
      set(() => ({ homeCalendarDateRange: dateRange })),
    selectedInflowFilter: null,
    updateSelectedInflowFilter: (filter) =>
      set(() => ({ selectedInflowFilter: filter })),
    selectedAging: null,
    updateSelectedAging: (aging) => set(() => ({ selectedAging: aging })),
    isTodaysPackages: true,
    updateIsTodaysPackages: (isTodaysPackages) =>
      set(() => ({ isTodaysPackages })),
    selectedPodType: null,
    updateSelectedPodType: (podNumber) =>
      set(() => ({ selectedPodType: podNumber })),
    updateSelectedInboundSortFilter: (filter) =>
      set(() => ({ selectedInboundSortFilter: filter })),
  })
);
